/* eslint-disable react/jsx-props-no-spreading */
import { Fragment, FunctionalComponent, RefObject, createRef, h } from 'preact';
import { Tab, TabList, TabPanel, useTabs } from '../../components/Tabs';
import CategoriesList from '../../components/CategoriesList';
import { DefaultUISettings } from '@usercentrics/cmp-browser-sdk';
import ServicesList from '../../components/ServicesList';
import { TAB_VIEW } from '../../enums/Tabs';
import { memo } from 'preact/compat';
import { useEffect } from 'preact/hooks';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Props = {
  scrollerRef?: RefObject<HTMLDivElement> | undefined;
};

const DefaultTabs: FunctionalComponent<Props> = memo(({ scrollerRef }) => {
  const { settings } = useSettingsContext();
  const { selected, select } = useTabs();
  const ui = settings.ui as DefaultUISettings;

  const initialTab = TAB_VIEW.CATEGORIES_PURPOSES;

  const stickyRef = createRef();

  useEffect(() => {
    if (!selected) {
      select(initialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <TabList ariaLabel="SettingsTabs" ref={stickyRef}>
        <Tab
          testid="uc-tab-categories"
          forPanel={TAB_VIEW.CATEGORIES_PURPOSES}
          ariaLabel={`${ui.secondLayer.tabs.categories.label} ${ui.ariaLabels.tabButton}`}
        >
          {ui.secondLayer.tabs.categories.label}
        </Tab>
        <Tab
          testid="uc-tab-services"
          forPanel={TAB_VIEW.SERVICES_VENDORS}
          ariaLabel={`${ui.secondLayer.tabs.services.label} ${ui.ariaLabels.tabButton}`}
        >
          {ui.secondLayer.tabs.services.label}
        </Tab>
      </TabList>
      <Fragment>
        <TabPanel id={TAB_VIEW.CATEGORIES_PURPOSES} testid="uc-panel-categories">
          <CategoriesList
            ref={scrollerRef}
            stickyRef={stickyRef}
            isVisible={selected === TAB_VIEW.CATEGORIES_PURPOSES}
            showServicesToggles={!ui.secondLayer.hideTogglesForServices}
          />
        </TabPanel>
        <TabPanel id={TAB_VIEW.SERVICES_VENDORS} testid="uc-panel-services">
          <ServicesList
            ref={scrollerRef}
            stickyRef={stickyRef}
            controllerIdLabel={ui.labels.general.controllerId}
            isVisible={selected === TAB_VIEW.SERVICES_VENDORS}
            showServicesToggles={!ui.secondLayer.hideTogglesForServices}
          />
        </TabPanel>
      </Fragment>
    </Fragment>
  );
});

export default DefaultTabs;
